import _ from 'lodash';
import * as mathematica from '../Utils/mathematica';
export default {
  methods: {
    inputOnBackgroundCheckGameAction() {
      let entanglements = {};
      let status = _.reduce(
        this.inputData,
        (result, value, key) => {
          let temVal = null;

          /**
           * if entanglements is set by coupled property
           * @method if
           * @param  {Object} value input object
           * @return {object}       entanglements oject with keys
           */
          if (value.coupled && _.isNil(entanglements[value.coupled])) {
            entanglements = _.extend({}, entanglements, {
              [value.coupled]: [],
            });
          }
          let index;
          if (_.isNil(value.correct)) {
            value.correct = [''];
          }
          let correctArray = _.isArray(value.correct) ? value.correct : [value.correct];
          if (value.coupled) {
            /**
             * set correct array without element already used in this entanglement
             * @type {array}
             */
            correctArray = _.difference(correctArray, entanglements[value.coupled]);
          }
          if (value.mathematica && value.mathematica.expression) {
            let options = value.mathematica.expression;

            if (options.test && options.multipleLine) {
              index = _.findIndex(correctArray, (o) => {
                let test1 = mathematica.expressionTestMultipleLine(value.val);
                let expr1 = mathematica.expressionCalculate(value.val);
                let expr2 = mathematica.expressionCalculate(o);
                return test1 && parseFloat(expr1) === parseFloat(expr2);
              });
            } else if (options.test && options.multipleEqual) {
              index = _.findIndex(correctArray, (o) => {
                let test1 = mathematica.expressionTestMultipleEqual(value.val);
                let expr1 = mathematica.expressionCalculate(value.val);
                let expr2 = mathematica.expressionCalculate(o);
                return test1 && parseFloat(expr1) === parseFloat(expr2);
              });
            }
            // TODO: poprawić sprawdzanie dla działań innych niż równania
            // else if (options.test && options.multipleOperations) {
            //              index = _.findIndex(correctArray, (o) => {
            //                let test1 = mathematica.expressionTestMultipleEqual(value.val);
            //                let expr1 = mathematica.expressionCalculate(value.val);
            //                let expr2 = mathematica.expressionCalculate(o);
            //                return test1 && parseFloat(expr1) === parseFloat(expr2);
            //              });
            //            }
            else if (options.test) {
              index = _.findIndex(correctArray, (o) => {
                let expr = mathematica.expressionProcess(value.val);
                expr = expr[0];
                let expr2 = mathematica.expressionProcess(o);
                expr2 = expr2[0];
                let test1 = mathematica.expressionTest(value.val);
                return test1 && mathematica.isEqual(expr, expr2);
              });
            } else if (options.calculate) {
              index = _.findIndex(correctArray, (o) => {
                let expr = mathematica.expressionCalculate(value.val);
                let expr2 = parseFloat(o);
                return parseFloat(o) === parseFloat(expr);
              });
            }
          } else {
            index = _.findIndex(correctArray, (o) => {
              if (value.caseSensitive) {
                return o === _.trim(value.val);
              } else {
                return _.trim(o?.toLowerCase()) === _.trim(value?.val?.toLowerCase());
              }
            });
          }
          if (index != -1 || value.exclude === true) {
            temVal = result && true;
            if (value.coupled) {
              /**
               * set value.val as 'use' in entanglements array
               * @type {[type]}
               */
              entanglements[value.coupled].push(value.val);
            }
            let replaceList;
            if (!value.replace) {
              value.replace = [];
            }
            if (!_.isArray(value.replace)) {
              value.replace = _.map([1], () => {
                return value.replace;
              });
            }

            if (!_.isEmpty(value.replace)) {
              let replaceIndex = -1;
              replaceIndex = _.indexOf(value.correct, value.val);
              if (replaceIndex != -1) {
                value.val = value.replace[replaceIndex];
              }
            }
            if (value.exclude) {
              value.val = _.trim(value.val);
              value.block = false;
              value.inputStatus = 'unset';
            } else {
              value.val = _.trim(value.val);
              value.block = true;
              value.inputStatus = 'correct';
            }
          } else {
            temVal = false;
            value.val = '';
            value.block = true;
            value.inputStatus = 'incorrect';
            setTimeout(() => {
              value.val = '';
              value.block = false;
              value.inputStatus = null;
            }, 1000);
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.inputData, (item, key) => {
          console.log('item', item);
        });
      }
      return status;
    },
  },
};
